import React, { lazy, Suspense } from 'react';
import { RouterProvider } from 'react-router/dom';
import { createBrowserRouter } from 'react-router';

const router = createBrowserRouter([
    {
        path: 'calendar',
        lazy: {
            Component: async () => (await import('./KXApp')).default,
        },
        hydrateFallbackElement: <p>Loading...</p>,
        //errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                lazy: {
                    Component: async () => (await import('../pages/CalendarIndex')).default,
                }
            },
            {
                path: 'month/:year/:month',
                lazy: {
                    Component: async () => (await import('../pages/CalendarMonthView')).default,
                },
                hydrateFallbackElement: <div>Loading...</div>,
            },
            {
                path: 'event/:type/:id',
                lazy: {
                    Component: async () => (await import('../pages/CalendarEvent')).default,
                },
                hydrateFallbackElement: <div>Loading...</div>,
            },
        ]
    },
]);

export default function Routes() {
    return <RouterProvider router={router} />;
}
